const Home = () => (
  <section className="hero">
    <div className="hero-body">
      <div className="container"></div>
    </div>
  </section>
);

export default Home;
